<template>
  <footer class="footer">
    <section class="footer__container">
      <div class="footer__col left">
        <p class="footer__rights a-font__s">
          © 2000 – {{ new Date().getFullYear() }} МТИ. Все права защищены
        </p>
        <AppPersonalAgreementDialog>
          <a
            class="footer__privacy a-font__s"
            href="/my/files/policy.pdf"
            target="_blank"
          >
            {{ $t('footer.policy') }}
          </a>
        </AppPersonalAgreementDialog>
      </div>

      <div class="footer__col right">
        <ul class="footer__social-list">
          <li class="footer__social-item">
            <a
              class="footer__social-link"
              href="https://t.me/mti_institute"
              target="_blank"
            >
              <img
                src="@/projects/mti/assets/img/footer/telegram.svg"
                alt=""
              />
            </a>
          </li>
          <li class="footer__social-item">
            <a
              class="footer__social-link"
              href="https://dzen.ru/mti_institute"
              target="_blank"
            >
              <img
                src="@/projects/mti/assets/img/footer/dzen.svg"
                alt=""
              />
            </a>
          </li>
          <li class="footer__social-item">
            <a
              class="footer__social-link"
              href="https://vk.com/mti_vuz"
              target="_blank"
            >
              <img
                src="@/projects/mti/assets/img/footer/vk.svg"
                alt=""
              />
            </a>
          </li>
        </ul>
      </div>

      <div class="phone">
        <div class="phone-title">
          Телефон
        </div>
        <a
          href="tel:88001008595"
          class="phone-link"
        >
          8 800 100-85-95
        </a>
      </div>
    </section>
  </footer>
</template>

<script setup lang="ts">
import AppPersonalAgreementDialog from '@/shared/components/AppPersonalAgreementDialog/AppPersonalAgreementDialog.vue';
</script>

<style lang="scss">
@import './TheFooter.scss';

.phone-title {
  font-size: rem(20);
  font-weight: 600;
  margin-bottom: rem(10);
}

a.phone-link.phone-link {
  font-size: rem(18);
  font-weight: 500;
  color: var(--footerLinkBackground);
  white-space: nowrap;
}
</style>
